import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import { Breadcrumbs, Container, Typography } from '@mui/material'
import React from 'react'
import { Link as RouterLink, useLocation } from 'react-router-dom'

const linkStyle = {
    color: 'neutral.400',
    '&:link': {
        textDecoration: 'none',
        color: 'neutral.400'
    },
    '&:visited': {
        textDecoration: 'none',
        color: 'neutral.400'
    },
    '&:hover': {
        textDecoration: 'none',
        color: 'neutral.400'
    },
    '&:active': {
        textDecoration: 'none',
        color: 'neutral.400'
    }
}

const pathsWeDonotWantToDisplay = ['group', 'event']

const Breadcrumb = () => {
    const location = useLocation()
    const pathnames = location.pathname.split('/').filter((x) => x)
    const shouldDisplayBreadcrumbs =
        pathnames.length > 1 ||
        (pathnames.length === 1 && pathnames[0].toLowerCase() !== 'home')

    // remove paths we don't want to display and concat with the last word in the pathnames
    pathsWeDonotWantToDisplay.forEach((path) => {
        if (pathnames.includes(path)) {
            pathnames.splice(pathnames.indexOf(path), 1)
            pathnames[pathnames.length - 1] =
                `${path}-${pathnames[pathnames.length - 1]}`
        }
    })

    return (
        <>
            <Container>
                <Breadcrumbs
                    separator={<NavigateNextIcon fontSize="small" />}
                    aria-label="breadcrumb"
                    sx={{ mb: 4 }}
                >
                    {shouldDisplayBreadcrumbs && (
                        <Typography
                            component={RouterLink}
                            sx={linkStyle}
                            to="/"
                        >
                            home
                        </Typography>
                    )}
                    {pathnames.map((name, index) => {
                        const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`
                        const isLast = index === pathnames.length - 1
                        return isLast ? (
                            <Typography sx={linkStyle} key={name}>
                                {name}
                            </Typography>
                        ) : (
                            <Typography
                                component={RouterLink}
                                sx={linkStyle}
                                to={routeTo}
                                key={name}
                            >
                                {name}
                            </Typography>
                        )
                    })}
                </Breadcrumbs>
            </Container>
        </>
    )
}

export default Breadcrumb

{
    /* <Breadcrumbs */
}
{
    /*    aria-label="breadcrumb" */
}
{
    /*    separator={<ChevronRightIcon fontSize="small" />} */
}
{
    /*    sx={{ mt: 1 }} */
}
{
    /* > */
}
{
    /*    <Link */
}
{
    /*        color="textPrimary" */
}
{
    /*        component={RouterLink} */
}
{
    /*        to="/" */
}
{
    /*        variant="subtitle2" */
}
{
    /*    > */
}
{
    /*        Dashboard */
}
{
    /*    </Link> */
}
{
    /*    <Typography */
}
{
    /*        color="textSecondary" */
}
{
    /*        variant="subtitle2" */
}
{
    /*    > */
}
{
    /*        Calendar */
}
{
    /*    </Typography> */
}
{
    /* </Breadcrumbs> */
}
